import React from 'react';
import { Box, Title, Image } from "rbx";
import moment from 'moment';

const styleHr = {
  backgroundColor: 'transparent', 
  borderColor: 'rgb(221, 221, 221)', 
  borderStyle: 'dashed', 
  borderWidth: '1px 0px 0px', 
  margin: '3px'
};

const NotificationsDetail = (props) => {

  return (
    <Box>
      <Title size={5} className="mb-4">Detalhes da Notificação</Title>
      <hr style={ styleHr }/>

      <small><strong>Título</strong></small><br />
      {props.title}
      <hr style={ styleHr }/>

      <small><strong>Criada em</strong></small><br />
      {moment(props.createdAt).format('DD/MM/YYYY HH:mm:ss')}
      <hr style={ styleHr }/>

      <small><strong>Mensagem</strong></small><br />
      {props.message}
      <hr style={ styleHr }/>

      <small><strong>Imagem</strong></small><br />
      <Image.Container size={128}>
        <Image src={props.imageUrl} />
      </Image.Container>
    </Box>
  )

}

export default NotificationsDetail;

